import { LeadSuccessModule } from './../lead-success/lead-success.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputModule } from './../input/input.module';
import { IntlInputModule } from './../intl-input/intl-input.module';
import { CommonTalktousModalComponent } from './components/common-talktous-modal/common-talktous-modal.component';
import { CaptchaInputModule } from '../captcha-input/captcha-input.module';
import { CaptchaModule } from '../captcha/captcha.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    IntlInputModule,
    LeadSuccessModule,
    CaptchaInputModule,
    CaptchaModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule
  ],
  declarations: [CommonTalktousModalComponent],
  bootstrap: [CommonTalktousModalComponent],
  exports: [CommonTalktousModalComponent],

})
export class CommonTalktousModalModule {
  getComponent() {
    return CommonTalktousModalComponent;
  }
}
